import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FiClock } from "react-icons/fi";
import { PiMapPinLight, PiClockLight, PiUserLight, PiTagLight, PiPencilSimpleLight } from "react-icons/pi";
import { FiInfo } from "react-icons/fi";
import DietaryPopup from "./DietaryPopup";


import { useNavigate } from "react-router-dom";  

import OccasionsPopup from "./OccasionsPopup"


export default function BookingFormPage() {
  const [selected, setSelected] = useState({
    date: "",
    guests: "",
    time: "",
  });

  const [remainingSeconds, setRemainingSeconds] = useState(300); // 5:00

  useEffect(() => {
    setSelected({
      date: localStorage.getItem("selectedDate") || "",
      guests: localStorage.getItem("selectedGuests") || "",
      time: localStorage.getItem("selectedTime") || "",
    });

    const interval = setInterval(() => {
      setRemainingSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const formatTime = (sec) => {
    const m = Math.floor(sec / 60).toString().padStart(1, "0");
    const s = (sec % 60).toString().padStart(2, "0");
    return `${m}:${s}`;
  };

const [showDietary, setShowDietary] = useState(false);
const [showOccasion, setShowOccasion] = useState(false); 
const navigate = useNavigate()

  return (
    <div
      className="min-h-screen bg-cover bg-center px-4 py-10 flex items-start justify-center"
      style={{ backgroundImage: "url('/bg.png')" }}
    >
      <div className="w-full max-w-2xl bg-[#F1F1F1] rounded-lg shadow-xl p-6 space-y-6 text-center">
        {/* Header Info */}
        <div className="text-sm text-neutral-600">
          {selected.date} · {selected.guests} Guest
          {selected.guests > 1 ? "s" : ""} · {selected.time}
        </div>

        {/* Timer */}
      <div className="text-sm text-gray-600 flex items-center justify-center gap-2">
  <FiClock className="text-base" />
  We’re holding this table for{" "}
  <span className="font-semibold">{formatTime(remainingSeconds)}</span> minutes
</div>

        {/* Title */}
        <h2 className="text-md font-medium text-neutral-800">
          Please input your details in English only
        </h2>

        {/* Form */}
        <div className="bg-[#F1F1F1] p-6 rounded-lg shadow-xl text-left space-y-4">
          {/* Name fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              type="text"
              placeholder="First Name *"
              className="p-3 bg-[#F1F1F1] focus:outline-none rounded-md w-full text-sm"
            />
            <input
              type="text"
              placeholder="Last Name *"
              className="bg-[#F1F1F1] focus:outline-none p-3 rounded-md w-full text-sm"
            />
          </div>

          {/* Email */}
          <input
            type="email"
            placeholder="Email Address *"
            className="bg-[#F1F1F1] focus:outline-none p-3 rounded-md w-full text-sm"
          />

          {/* Phone Number with flag input */}
          <div className="w-full">
            <PhoneInput
              country={"ae"}
              enableSearch
              inputStyle={{
                width: "100%",
                height: "44px",
                fontSize: "14px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                paddingLeft: "58px",
                backgroundColor: "#F1F1F1",
                lineHeight: "44px",
              }}
              buttonStyle={{
                border: "none",
                background: "transparent",
                padding: "0",
                marginLeft: "10px",
                marginTop: "4px",
                height: "36px",
              }}
              containerStyle={{
                width: "100%",
              }}
              dropdownStyle={{
                zIndex: 1000,
              }}
            />
          </div>

          {/* Birthday */}
          <input
            type="text"
            placeholder="Birthday"
            className="p-3 bg-[#F1F1F1] focus:outline-none rounded-md w-full text-sm"
          />
        </div>



{/* Summary Panel */}
<div className="mt-8 bg-[#F1F1F1] rounded-xl shadow-xl p-6 space-y-6 text-left">
  <h3 className="text-center text-md font-medium text-neutral-800 mb-2">Summary</h3>

  {/* Location */}
  <div className="flex items-start gap-3">
    <PiMapPinLight className="text-xl" />
    <div className="text-sm font-semibold text-neutral-600">Nammos Dubai</div>
  </div>

  {/* Date & Time */}
  <div className="flex items-start font-semibold gap-3">
   <PiClockLight className="text-xl" />
    <div className="text-sm text-neutral-600">
      Thu, 22 May · 14:00 - 16:00 · Lunch
    </div>
  </div>

  {/* Guests */}
  <div className="flex items-start gap-3">
   	<PiUserLight className="text-xl" />
    <div className="text-sm font-semibold text-neutral-600">2 Guests</div>
  </div>

  {/* Dietary Restrictions */}
  <div className="flex items-center justify-between font-semibold text-sm text-neutral-600">
    <div className="flex items-center gap-3">
    <PiTagLight className="text-xl" />
      Dietary Restrictions
    </div>
    <button onClick={() => setShowDietary(true)}

 className="border border-black text-xs px-3 py-1 rounded hover:bg-gray-100">+ Add</button>
  </div>

  {/* Special Occasions */}
  <div className="flex items-center font-semibold justify-between text-sm text-neutral-600">
    <div className="flex items-center gap-3">
       <PiTagLight className="text-xl" />
      
      Special Occasions
    </div>
    <button  onClick={() => setShowOccasion(true)} className="border border-black text-xs px-3 py-1 rounded hover:bg-gray-100">+ Add</button>
   
  
  </div>




  {/* Reservation Notes */}
  <div className="flex font-semibold items-start gap-3">
 	<PiPencilSimpleLight className="text-xl" />
    <div className="text-sm text-neutral-600">Reservation Notes</div>
  </div>

  {/* Checkboxes */}
  <div className="space-y-3 pt-2">
    <div className="flex items-start gap-3">
      <input type="checkbox" className="mt-1" />
      <label className="text-sm text-neutral-900">
        Receive news and offers for Nammos Dubai
      </label>
      <span className="ml-auto text-2xl   text-neutral-900">ⓘ</span>
    </div>

    <div className="flex items-start gap-3">
      <input type="checkbox" className="mt-1" /> 
      <label className="text-sm text-neutral-900">
        Receive news and offers for all our locations
      </label>
      <span className="ml-auto text-2xl   text-neutral-900">ⓘ</span>
    </div>

    <div className="flex items-start gap-3">
      <input type="checkbox" className="mt-1"   />
      <label className="text-sm text-neutral-900">
        I agree to receive automated text messages, such as reservation reminders, at the phone number provided.
      </label>
      <span className="ml-auto text-2xl   text-neutral-900">ⓘ</span>
    </div>
  </div>
</div>


{/* Submit & Footer */}
<div className="mt-10 space-y-4 text-center">
  <p className="text-[13px] text-gray-500">
    By clicking "submit" you agree to SevenRooms’{" "}
    <span className="underline">Terms of Service</span> and{" "}
    <span className="underline">GDPR Policy</span>
  </p>

  <button onClick={()=>navigate('/checkout')} className="w-full bg-white border border-gray-300 py-3 rounded-md text-neutral-800 font-base hover:bg-gray-200 transition">
    Submit
  </button>

  <div className="text-xs text-neutral-800   ">
 <p className="mt-20">   Experience By SEVENROOMS    </p>    
  </div>
</div>

      </div>
{showDietary && (
  <DietaryPopup
    onClose={() => setShowDietary(false)}
    selected={[]} // можно передать текущие значения
    onSave={(selectedList) => {
      console.log("Saved:", selectedList);
      setShowDietary(false);
    }}
  />
)}




    </div>
  );
}
